import * as React from 'react';
export var TextBlock = function (_a) {
    var image = _a.image, title = _a.title, reverse = _a.reverse, children = _a.children;
    return (React.createElement("div", { className: "text-block ".concat(reverse ? 'reverse' : 'normal') },
        React.createElement("div", { className: "text-block-teaser" },
            React.createElement("img", { src: image, alt: typeof title === 'string' ? title : 'Teaser', className: "circle shadow" })),
        React.createElement("div", { className: "text-block-content" },
            React.createElement("h2", null, title),
            children)));
};
//# sourceMappingURL=index.js.map